import PropTypes from "prop-types";

const propTypes = {
  zmluva: PropTypes.shape({
    I_ZMLUVY: PropTypes.number,
    I_ORGAN: PropTypes.number,
    C_ZMLUVY: PropTypes.string,
    D_UCINNOSTI: PropTypes.instanceOf(Date),
    D_UKONCENIA: PropTypes.instanceOf(Date),
    D_VYHOTOVENIA: PropTypes.instanceOf(Date),
    N_UHRADA: PropTypes.string,
    ADRESA_ZMLUVY_KOR: PropTypes.string,
    OBEC_KOR: PropTypes.string,
    ULICA_KOR: PropTypes.string,
    CS_KOR: PropTypes.number,
    CO_KOR: PropTypes.string,
    PSC_KOR: PropTypes.string,
    IBAN: PropTypes.string,
    I_DODAVATEL: PropTypes.number,
    LIST_OM: PropTypes.string,
  }),
};

export default propTypes;
